export enum LinkType {
  NotSet = 'NotSet',
  Tel = 'Tel',
  Email = 'Email',
  Url = 'Url',
}
